/* GG · Product · Sticky ATC
   Permanently visible from page load (not scroll-gated). Submits by calling
   requestSubmit() on the real product form — reuses Dawn's product-form.js
   entirely (loading state, error handling, cart-drawer open + AJAX render).
   No cart logic is reimplemented here. Price/availability sync via
   PUB_SUB_EVENTS. Reserves matching space at the bottom of <body> so the
   fixed bar never covers the footer/last section. */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-gg-satc]');
    if (!bar) return;

    var btn = bar.querySelector('[data-gg-satc-btn]');
    var btnLabel = bar.querySelector('[data-gg-satc-btn-label]');
    var priceEl = bar.querySelector('[data-gg-satc-price]');
    var thumbEl = bar.querySelector('[data-gg-satc-thumb]');
    var defaultLabel = btnLabel ? btnLabel.textContent.trim() : '';

    var mainForm = document.querySelector('[data-type="add-to-cart-form"]');
    var mainBtn = mainForm ? mainForm.querySelector('[name="add"]') : null;

    function reserveSpace() {
      document.body.style.paddingBottom = bar.offsetHeight + 'px';
    }
    reserveSpace();
    window.addEventListener('resize', reserveSpace);

    if (btn && mainForm) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        mainForm.requestSubmit ? mainForm.requestSubmit() : mainForm.submit();
      });
    }

    // Keep sticky bar's disabled/sold-out state mirrored to the main button.
    if (mainBtn && btn) {
      var syncDisabled = function () {
        var disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
        btn.disabled = disabled;
      };
      syncDisabled();
      new MutationObserver(syncDisabled).observe(mainBtn, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }

    // Price / thumb / label sync on variant change.
    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var variant = evt && evt.data && evt.data.variant;
        if (!variant) return;

        if (priceEl && typeof variant.price === 'number') {
          priceEl.textContent = formatMoney(variant.price);
        }
        if (btnLabel) {
          btnLabel.textContent = variant.available === false
            ? ((window.variantStrings && window.variantStrings.soldOut) || 'Ausverkauft')
            : defaultLabel;
        }
        if (thumbEl && variant.featured_media && variant.featured_media.preview_image) {
          var src = variant.featured_media.preview_image.src;
          if (src) thumbEl.src = src.replace(/(\.[a-z]+)(\?|$)/i, '_80x80_crop_center$1$2');
        }
        if (btn) btn.disabled = variant.available === false;
        reserveSpace();
      });
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.moneyFormat) {
        return Shopify.formatMoney(cents, window.moneyFormat);
      }
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
